import React from "react";
import useFetch from "@/lib/useFetch";
import api from "@/lib/api";
import { PageHeader, Footer } from "@/components/common/Page";
import Loader from "@/components/common/Loader";
import { timeAgo } from "@/lib/communities";
import { Bell } from "lucide-react";

export default function Notifications() {
    const { data, reload } = useFetch("/notifications");
    if (!data) return <Loader />;

    const markRead = async (n) => {
        if (n.read) return;
        await api.post(`/notifications/${n.id}/read`);
        reload();
    };

    const color = { critical: "#EF4444", high: "#F59E0B", reward: "#00FF66", info: "#FF6B00" };

    return (
        <div data-testid="player-notifications">
            <PageHeader title="Notifications" subtitle="Alerts from across the network." />
            <div className="space-y-2">
                {data.length === 0 && <div className="text-muted-foreground">No notifications.</div>}
                {data.map((n) => (
                    <button key={n.id} data-testid={`notification-${n.id}`} onClick={() => markRead(n)}
                        className="w-full text-left flex items-start gap-3 tactical-card rounded-md p-4 hover:border-hazard/40 transition-colors">
                        <div className="rounded-md p-2" style={{ background: `${color[n.type] || "#FF6B00"}18` }}>
                            <Bell size={16} style={{ color: color[n.type] || "#FF6B00" }} />
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2">
                                <span className="font-heading font-semibold uppercase text-foreground">{n.title}</span>
                                {!n.read && <span className="h-2 w-2 rounded-full bg-hazard" />}
                            </div>
                            <p className="text-sm text-muted-foreground">{n.body}</p>
                            <span className="label-mono text-muted-foreground">{timeAgo(n.created_at)}</span>
                        </div>
                    </button>
                ))}
            </div>
            <Footer />
        </div>
    );
}
